var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"key-con"},[_c('div',{staticClass:"keyboardContainer",class:[_vm.keyboardType]},[_c('div',{ref:"simpleKeyboardMainDom",staticClass:"simple-keyboard-main"})]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGesture),expression:"showGesture"}],staticClass:"gesture"},[_c('div',{staticClass:"left_gesture",style:({
        backgroundImage: `url(${_vm.leftGestureDa})`,
        opacity: 0.5,
      })}),_c('div',{staticClass:"right_gesture",class:{
        right_top_row: _vm.rightGestureKey.includes('right-top-row'),
        right_bottom_row: _vm.rightGestureKey.includes('right-bottom-row'),
        special_right: _vm.specialRightGestures.includes(_vm.nextInput),
      },style:({
        backgroundImage: `url(${_vm.rightGestureDa})`,
        opacity: 0.5,
      })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }